import React, { FC, ReactNode } from 'react'
import Popover from '@/components/atoms/Popover/Popover'
import BottomSheet from '@/components/atoms/BottomSheet/BottomSheet'
import { ArrowRight, ArrowRightShort } from 'react-bootstrap-icons'
import { ButtonProps } from '@/components/atoms/Button/ButtonV2'
import * as PopperJS from '@popperjs/core'

export interface ResponsivePopoverProps {
  header: string | ReactNode
  description: string
  buttonText?: string
  buttonLink?: string
  buttonType?: ButtonProps['type']
  children: ReactNode
  placement?: PopperJS.Placement
}

const ResponsivePopover: FC<ResponsivePopoverProps> = ({
  header,
  description = '',
  buttonText = '',
  buttonLink = '',
  buttonType = 'secondary',
  children,
  placement = 'bottom-start'
}) => {
  return (
    <>
      <div className="md:hidden">
        <BottomSheet
          header={header}
          description={description}
          buttonText={buttonText}
          buttonLink={buttonLink}
          buttonIcon={<ArrowRight size="16" />}
          buttonType={buttonType}
        >
          {children}
        </BottomSheet>
      </div>
      <div className="hidden md:block">
        <Popover
          header={header}
          description={description}
          buttonLinkText={buttonText}
          buttonLinkTarget={buttonLink}
          buttonLinkIcon={<ArrowRightShort size="16" />}
          placement={placement}
        >
          {children}
        </Popover>
      </div>
    </>
  )
}

export default ResponsivePopover
